import React from "react";
import styles from "./Footer.module.css";

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <p>© 2025 HamManager. All rights reserved.</p>
        </footer>
    );
};

export default Footer;